import { ResponseError } from 'services/api/base';
import type { ChartType } from 'types/Meteorology/TrackingForecast';

import { MapToSubmenuOption } from './submenuOptions';

export type Subpage = 'locations' | 'members' | 'models' | 'rounds';

export const SUBPAGE_NAMES = {
  locations: 'Multi locais',
  members: 'Multi membros',
  models: 'Multi modelos',
  rounds: 'Multi rodadas',
};

export const SUBPAGE_SUBMENU_OPTIONS: MapToSubmenuOption = {
  locations: 'multi-locais',
  members: 'multi-membros',
  models: 'multi-modelos',
  rounds: 'multi-rodadas',
};

export interface ChartStatus {
  data: object | undefined;
  error: ResponseError | undefined;
  isFetching: boolean;
}

export type ChartData = {
  [subpage in Subpage]: {
    [chartType in ChartType]: ChartStatus;
  };
};
